import React, { useEffect, useState } from 'react';
import axios from 'axios';
import JsonViewer from 'react-json-prettify';
import { googlecode } from 'react-json-prettify/dist/themes';
import HeaderLogged from './HeaderLogged';
import Sidebar from './Sidebar';
import './styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

const AUTHORIZATION_TOKEN = 'Bearer 55c2fad3-45a4-4e29-b9cf-911d7cf6131f';

const AskDataPage = () => {
  const [question, setQuestion] = useState('');
  const [limit, setLimit] = useState(50);
  const [result, setResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('user') === null) {
      window.location.href = '/';
    }
  }, []);

  const getCurrentCompanyID = () => {
    const storedUser = localStorage.getItem('user');

    if (!storedUser) {
      return null;
    }

    const user = JSON.parse(storedUser);
    return user.companyID;
  };

  const formatDate = (dateValue) => {
    if (!dateValue) {
      return '';
    }

    const date = new Date(dateValue);

    if (Number.isNaN(date.getTime())) {
      return dateValue;
    }

    return date.toLocaleString('pt-BR');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const companyID = getCurrentCompanyID();

    if (!companyID) {
      window.location.href = '/';
      return;
    }

    setIsLoading(true);
    setResult(null);
    setErrorMessage('');

    try {
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + '/api/AskData',
        JSON.stringify({
          companyID,
          question,
          limit: Number(limit)
        }),
        {
          headers: {
            Authorization: AUTHORIZATION_TOKEN,
            'Content-Type': 'text/plain'
          }
        }
      );

      setResult(response.data);
    } catch (error) {
      console.error(error);
      setErrorMessage('Não foi possível consultar os dados. Verifique a pergunta e tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  const rows = result && Array.isArray(result.Rows) ? result.Rows : [];

  return (
    <div className="container-fluid p-0">
      <HeaderLogged />
      <div className="row showContentMargin">
        <div className="col-3 col-lg-auto col-xxl-2" id="divSidebar">
          <Sidebar />
        </div>
        <main className="container col-lg-10 col-xxl-9 p-4" id="divContent">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-12">
                <h3>Perguntar aos Dados</h3>
              </div>
              <div className="col-md-9 mt-3">
                <label htmlFor="question" className="fs-5">Pergunta:</label>
                <textarea
                  id="question"
                  className="form-control askDataQuestion"
                  value={question}
                  onChange={(event) => setQuestion(event.target.value)}
                  placeholder="Ex: Comparando as últimas 3 execuções dos contratos sociais, quais delas retornou um json mais completo?"
                  required
                />
              </div>
              <div className="col-md-3 mt-3">
                <label htmlFor="limit" className="fs-5">Limite:</label>
                <input
                  type="number"
                  id="limit"
                  className="form-control"
                  min="1"
                  max="500"
                  value={limit}
                  onChange={(event) => setLimit(event.target.value)}
                  required
                />
                <button type="submit" disabled={isLoading} className="btn btn-success btn-lg w-100 mt-4">
                  {isLoading && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                  {isLoading ? 'Consultando...' : 'Perguntar'}
                </button>
              </div>
            </div>
          </form>

          {errorMessage && (
            <div className="alert alert-danger mt-4" role="alert">
              {errorMessage}
            </div>
          )}

          {result && (
            <div className="row mt-4">
              <div className="col-md-12">
                <div className="card shadow-sm">
                  <div className="card-body">
                    <h4 className="card-title">Resposta</h4>
                    <p className="fs-5 mb-0">{result.Answer}</p>
                  </div>
                </div>
              </div>

              <div className="col-md-12 mt-4">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <h4 className="mb-0">Registros encontrados</h4>
                  <span className="badge bg-success-subtle border border-success-subtle text-success-emphasis rounded-pill fs-6">
                    {rows.length}
                  </span>
                </div>

                {rows.length === 0 && (
                  <div className="alert alert-secondary" role="alert">
                    Nenhum registro retornado.
                  </div>
                )}

                <div className="accordion" id="askDataRows">
                  {rows.map((row, index) => {
                    const accordionId = `askDataRow${row.dataprocessID || 'item'}${index}`;

                    return (
                      <div className="accordion-item" key={accordionId}>
                        <h2 className="accordion-header">
                          <button
                            className={`accordion-button ${index === 0 ? '' : 'collapsed'}`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${accordionId}`}
                            aria-expanded={index === 0 ? 'true' : 'false'}
                            aria-controls={accordionId}
                          >
                            <span className="fw-semibold me-3">DataProcess ID: {row.dataprocessID}</span>
                            <span>{formatDate(row.processDate)}</span>
                          </button>
                        </h2>
                        <div
                          id={accordionId}
                          className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                          data-bs-parent="#askDataRows"
                        >
                          <div className="accordion-body askDataJson">
                            <JsonViewer
                              json={row}
                              theme={googlecode}
                              padding={4}
                              indent={2}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default AskDataPage;
